import styled from 'styled-components';

export const StyledViewButton = styled.button`
  border: none;
  color: ${({ theme }) => theme.hudButtonTextLight};
  background: ${({ theme }) => theme.hudButtonDark};
  width: 100%;
  height: 8vh;
  padding: 5px 5px;
  margin: 10px 0px;
  cursor: pointer;
  position: relative;
  z-index: 9999;

  .frame {
    border: solid 2px ${({ theme }) => theme.hudButtonFrame};
    background-color: ${({ theme }) => theme.hudButtonFrameBg};
    border-radius: 10px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    padding: 5px;
    gap: 10px;
    font-size: 16px;

    img {
      height: 100%;
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
  }

  &:hover {
    .frame {
      border: solid 2px ${({ theme }) => theme.hudButtonHover};
      background-color: ${({ theme }) => theme.hudButtonFrameBgHover};
    }
  }
`;
